import { ulid } from 'ulid';

/** 記事・メディアのID。ULID は時系列ソート可能で、端末間で衝突しない。 */
export function newId(): string {
  return ulid();
}

const DEVICE_ID_KEY = 'nj.deviceId';

/** 端末ごとに一度だけ生成し、以後固定。競合解決のタイブレークに使う（§7.5）。 */
export function getDeviceId(): string {
  let id = localStorage.getItem(DEVICE_ID_KEY);
  if (!id) {
    id = 'dev-' + ulid().toLowerCase().slice(-12);
    localStorage.setItem(DEVICE_ID_KEY, id);
  }
  return id;
}
